import { Box } from 'components/Box';

import {
  STAFF_PAGE_HEADER_NAV,
  STAFF_PAGE_HEADER_NAV_MAP,
} from './StaffPageHeaderConstants';
import { StaffPageHeaderNavLink } from './StaffPageHeaderNavLink';

type Props = {
  index: number;
  linkTo: string | { pathname: string; state: { redirectToContent?: boolean } };
  type: keyof typeof STAFF_PAGE_HEADER_NAV_MAP;
  isActive: (type: keyof typeof STAFF_PAGE_HEADER_NAV_MAP) => boolean;
  navInactive: boolean;
};

export function StaffPageHeaderTopNavLink({
  index,
  linkTo,
  type,
  isActive,
  navInactive,
}: Props) {
  return (
    <Box
      position="relative"
      height={[null, null, null, '100%']}
      display={['inline-block', null, null, 'flex']}
      alignItems="center"
    >
      <StaffPageHeaderNavLink
        data-qa-id={`nav-${type.toLowerCase().replace(/_/g, '-')}-link`}
        to={linkTo}
        $active={isActive(type)}
        $navInactive={navInactive}
        type={type}
        mr={index < STAFF_PAGE_HEADER_NAV.length - 1 ? '1.5em' : undefined}
      >
        <Box classes={['flex', 'align-center']}>
          {STAFF_PAGE_HEADER_NAV_MAP[type]}
        </Box>
      </StaffPageHeaderNavLink>
    </Box>
  );
}
